module.exports = __webpack_public_path__ + "static/media/Sort_unselected.e3bb90e1.svg";